import React from 'react';
import type { PaymentOption } from '@/types/components';
import { tv } from '@/utils/tv';

const price = tv({
  slots: {
    root: 'flex items-baseline gap-2 font-semibold text-foreground',
    period: 'font-semibold',
    previous: 'font-normal text-subtle-foreground line-through',
  },
  variants: {
    large: {
      true: {
        root: 'text-[30px]/[36px] md:text-[48px]/[64px]',
        period: 'text-title-24',
        previous: 'text-headline-20',
      },
      false: {
        root: 'text-[30px]/[36px] md:text-[36px]/[48px]',
        period: 'text-headline-20',
        previous: 'text-body-18',
      },
    },
  },
});

interface Props {
  option: PaymentOption;
  large?: boolean;
}

export const PlanPrice: React.FC<Props> = ({ option, large = false }) => {
  const { root, period, previous } = price({ large });

  return (
    <p className={root()}>
      <span>
        {option.currentPrice}
        {option.pricePeriodDescription && (
          <span className={period()}>{option.pricePeriodDescription}</span>
        )}
      </span>
      {option.previousPrice && (
        <span className={previous()}>{option.previousPrice}</span>
      )}
    </p>
  );
};
